import { Metrics } from "components/Metrics"
import { Contact } from "components/Contact"
import { Text } from "components/Text"
import { Wrapper } from "components/Wrapper"

export function PageIndexPage(props) {
  const { page, metrics } = props
  return (
    <div className="space-y-8">
      <div
        style={{
          backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${page.imageFile.url})`,
        }}
        className="bg-cover bg-center flex items-center justify-center h-64 text-white"
      >
        <Text className="text-center" variant="headline2" tag="h1">
          {page.title}
        </Text>
      </div>
      <Wrapper>
        <div
          dangerouslySetInnerHTML={{ __html: page.content }}
          className={"prose max-w-none"}
        />
      </Wrapper>
      <Metrics metrics={metrics} color="primary" />
      <Contact />
    </div>
  )
}
